<div class="w-full flex flex-col gap-6">
  <!-- Day Selection (Lunes to Sábado) -->
  <div class="flex flex-wrap gap-4 justify-start md:justify-center">
    @for (day of days; track day.key) {
      <div class="flex items-center gap-2">
        <!-- style for checkbox use bg secondary when checked -->
        <input
          type="checkbox"
          [id]="'day-' + day.key"
          [checked]="isDaySelected(day.key)"
          (change)="onDayChange(day.key, $any($event.target).checked)"
          class="w-4 h-4 cursor-pointer"
        />
        <label [for]="'day-' + day.key" class="cursor-pointer select-none">
          {{ day.name }}
        </label>
      </div>
    }
  </div>

  <!-- Time Range Inputs -->
  <div class="flex flex-wrap items-center gap-4">
    <div class="flex items-center gap-2">
      <label for="start-time" class="font-medium">De:</label>
      <input
        id="start-time"
        type="time"
        [ngModel]="startTime()"
        (ngModelChange)="onStartTimeChange($event)"
        class="border border-gray-300 rounded md:px-3 py-0.5 md:py-2 min-w-[110px] md:min-w-[120px]"
      />
    </div>
    
    <div class="flex items-center gap-2">
      <label for="end-time" class="font-medium">Hasta:</label>
      <input
        id="end-time"
        type="time"
        [ngModel]="endTime()"
        (ngModelChange)="endTime.set($event)"
        class="border border-gray-300 rounded px-1 md:px-3 py-0.5 md:py-2 min-w-[110px] md:min-w-[120px]"
      />
    </div>
    
    <button
      type="button"
      (click)="addSchedule()"
      [disabled]="isAddButtonDisabled()"
      class="flex items-center gap-2 px-4 py-2 bg-secondary text-white rounded hover:bg-secondary/80 disabled:bg-gray-300 disabled:cursor-not-allowed transition"
    >
      <span class="material-symbols-outlined">add</span>
      <span>Agregar</span>
    </button>
  </div>

  <!-- Info Message -->
  <div class="flex items-center justify-center w-full">
    <span class="text-sm text-purple-600">{{ infoMessage() }}</span>
  </div>

  <!-- Display Selected Schedules Grouped by Day -->
  @if (getDaysWithSchedules().length > 0) {
    <div class="flex flex-col gap-4 border-t-2 border-gray-300 pt-4">
      @for (day of getDaysWithSchedules(); track day.day) {
        <div class="flex gap-2 items-start md:items-center">
          <h4 class="font-semibold text-heading-primary">{{ day.day_name }}</h4>
          
          <div class="flex gap-2 ml-4 flex-wrap">
            @for (schedule of day.schedules; track $index) {
              <div class="min-w-[120px] flex items-center align-center justify-between bg-secondary/10 border border-secondary rounded-full px-2 py-0 md:py-1 gap-1 md:gap-2">
                <span class="text-gray-600 text-sm! md:text-base! whitespace-nowrap">
                  {{ schedule.start }} - {{ schedule.end }}
                </span>
                <button
                  type="button"
                  (click)="removeSchedule(day.day, schedule)"
                  class="text-red-600 hover:text-red-800 transition m-0! p-0! h-4!"
                  title="Eliminar horario"
                >
                  <span class="material-symbols-outlined text-[18px]! cursor-pointer">close</span>
                </button>
              </div>
            }
          </div>
        </div>
      }
    </div>
  }
</div>
